import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import Modal from 'react-modal';
import "../Reports.css";

Modal.setAppElement('#root');

function ResourceByAgentIdReport() {
    const [agentId, setAgentId] = useState("");
    const [resource, setResource] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleGenerateReport = async () => {
        setLoading(true);
        setErrorMessage("");
        try {
            const response = await axios.get(`https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/resource/${agentId}`);
            const resourceData = response.data.split("\n").map(line => line.split(": ")[1]);
            setResource({
                agentId: resourceData[0],
                nameAgent: resourceData[1],
                descriptionAgent: resourceData[2],
                typeAgent: resourceData[3],
                status: resourceData[4]
            });
            setAgentId("");
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setErrorMessage("Агент с таким ID не найден.");
                } else if (error.response.status === 400) {
                    setErrorMessage("Неверный формат идентификатора.");
                } else if (error.response.status === 500) {
                    setErrorMessage("Внутренняя ошибка сервера. Повторите позже.");
                } else {
                    setErrorMessage("Неизвестная ошибка.");
                }
                setModalIsOpen(true);
            } else {
                console.error("Ошибка при подключении:", error);
            }
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по идентификатору агента",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        new Paragraph({ text: `Идентификатор агента: ${resource.agentId}` }),
                        new Paragraph({ text: `Имя агента: ${resource.nameAgent}` }),
                        new Paragraph({ text: `Описание агента: ${resource.descriptionAgent || "Нет описания"}` }),
                        new Paragraph({ text: `Тип агента: ${resource.typeAgent}` }),
                        new Paragraph({ text: `Статус: ${resource.status}` }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "resource_by_agent_id_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>👤 Ресурс по ID</h2>

            <div className="otch-form-group">
                <input
                    type="text"
                    placeholder="Введите идентификатор агента"
                    value={agentId}
                    onChange={(e) => setAgentId(e.target.value)}
                    className="otch-form-input"
                />
            </div>

            {resource && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Агент: <span className="otch-highlight">{resource.nameAgent}</span>
                        <br />
                        Тип: <span className="otch-highlight">{resource.typeAgent}</span> |
                        Статус: <span className="otch-highlight">{resource.status}</span>
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading || !agentId.trim()}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "🔍 Найти агента"
                    )}
                </button>
                {resource && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                contentLabel="Ошибка"
                className="otch-modal"
                overlayClassName="otch-modal-overlay"
            >
                <h2 className="otch-modal-title">⚠️ Ошибка</h2>
                <p className="otch-modal-message">{errorMessage}</p>
                <button
                    onClick={() => setModalIsOpen(false)}
                    className="otch-modal-button"
                >
                    Понятно
                </button>
            </Modal>
        </div>
    );
}

export default ResourceByAgentIdReport;